export const getApiResult = (state, gid) => {
  return (state.entities.apiResultByGid || {})[gid];
};

export const getRegionalanalyseResult = (state, dataset) => {
  return (state.entities.apiResultByDataset || {})[dataset];
};

export const getNavResult = (state) => {
  return state.entities.navResult || null;
};

export const getDuckyByRegion = (state, region) => {
  return (state.entities.duckyResultByRegion || {})[region];
};
